import { render, staticRenderFns } from "./TabArea.vue?vue&type=template&id=25486bbc&"
import script from "./TabArea.vue?vue&type=script&lang=js&"
export * from "./TabArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports